// extracted by mini-css-extract-plugin
export var cardIcon = "_4h-4";
export var checkboxCard = "_4h-0";
export var checkboxCardSelected = "_4h-1";
export var disabled = "_4h-2";
export var outerBorder = "_4h-3";
export var spacerMedium = "_4h-7";
export var spacerSmall = "_4h-6";
export var spacerXsmall = "_4h-5";